import {useTranslation} from "@Translation/hooks/useTranslation";

export default function getPassengerTranslation(passengerIndex) {
    switch(passengerIndex) {
        case "":
            return useTranslation('check_order.check_order_first_passenger')
        case 1:
            return useTranslation('check_order.check_order_first_passenger')
        case 2:
            return useTranslation('check_order.check_order_additional_passenger')
        default:
            return useTranslation('check_order.check_order_passenger') + " " + passengerIndex
    }
}